export default {
    PROPOSTA: 'Proposta',
    HABILITACAO: 'Habilitação'
}